import { Outlet, createFileRoute } from '@tanstack/react-router'

/**
 * El despacho contable (`docs/adr/0021`). Las pantallas cuelgan de aquí; el
 * armazón lo pone la raíz: el de la cartera con la sesión del despacho, y el
 * del portal con la de un contribuyente —ahí `/despacho` es la puerta para
 * entrar a un despacho o registrar uno—.
 */
export const Route = createFileRoute('/despacho')({
  component: Outlet,
})
